import { PasswordAndSecurity } from '@features/profile/components/password-and-security/PasswordAndSecurity';
import * as React from 'react';

const PasswordAndSecurityRoute = React.memo((): React.ReactElement => {
  return <PasswordAndSecurity />;
});

PasswordAndSecurityRoute.displayName = 'PasswordAndSecurityRoute';

export { PasswordAndSecurityRoute };
